import jQuery from 'jquery';
import { addAction, doAction } from '@wordpress/hooks';
import { initMessagingBus, handleTitleChange, reanalyzeFromExternal } from './lib/embed-utils.js';
import {
  editPostMeta,
  POST_META_KEYS,
} from './lib/wp-data-utils';

class ClassicEditor {
  headlineElement;

  setup() {
    this.setCurrentHeadline();
    initMessagingBus(true);
    this.onHeadlineStudioLoad = this.onHeadlineStudioLoad.bind(this);
    addAction('headline_studio_loaded', 'hs-sidebar', this.onHeadlineStudioLoad, 0);
    this.reanalyzeFromExternal = reanalyzeFromExternal;
  }

  get currentHeadline() {
    return this.headlineElement?.value;
  }

  get postId() {
    return window.coscheduleHeadlineStudio.currentPostId;
  }

  onHeadlineStudioLoad() {
    this.registerTitleChangeListener();
  }

  registerTitleChangeListener() {
    this.headlineElement.addEventListener('keyup', () => {
      this.onTitleChange();
    });
  }

  async onTitleChange() {
    const {
      last_headline_text: lastHeadlineText,
      last_headline_score: lastHeadlineScore,
      last_seo_score: lastSeoScore,
    } = await this.getLastAnalyzedHeadline();

    handleTitleChange(this.headlineElement.value);

    let newScore = 0;
    let newHeadlineText = '';
    let newSeoScore = 0;

    if (this.currentHeadline !== lastHeadlineText) {
      console.log('headlines do not match');
    }

    if (this.currentHeadline === lastHeadlineText) {
      console.log('headlines match');
      newHeadlineText = lastHeadlineText;
      newScore = lastHeadlineScore;
      newSeoScore = lastSeoScore;
    }

    editPostMeta({
      [POST_META_KEYS.cos_headline_text]: newHeadlineText,
      [POST_META_KEYS.cos_headline_score]: newScore,
      [POST_META_KEYS.cos_seo_score]: newSeoScore,
      [POST_META_KEYS.cos_last_analyzed_headline]: {
        last_headline_text: lastHeadlineText,
        last_headline_score: lastHeadlineScore,
        last_seo_score: lastSeoScore,
      },
    }, {
      isClassicEditor: true,
    });

    return this.updatePublishMetaBoxValues(newScore, newSeoScore);
  }

  triggerAnalyzeFromPostMetaBox() {
    this.setMetaBoxButtonsToPending();
    this.reanalyzeFromExternal();
  }

  getMetaBoxNodes() {
    return {
      $headlineScore: jQuery('#meta-option-headline-score'),
      $seoScore: jQuery('#meta-option-seo-score'),
    };
  }

  setMetaBoxButtonsToPending() {
    const { $headlineScore, $seoScore } = this.getMetaBoxNodes();
    $headlineScore.text('Analyzing...');
    $seoScore.text('Analyzing...');
  }

  createAnalyzeButton(lastHeadlineText) {
    const reAnalyzeButton = document.createElement('a');
    reAnalyzeButton.role = 'button';
    reAnalyzeButton.innerHTML = lastHeadlineText ? 'Reanalyze' : 'Analyze';
    reAnalyzeButton.className = 'hide-if-no-js';

    if (this.currentHeadline) {
      reAnalyzeButton.href = '#';
      reAnalyzeButton.onclick = () => this.triggerAnalyzeFromPostMetaBox();
    }

    return reAnalyzeButton;
  }

  async updatePublishMetaBoxValues(newScore, newSeoScore) {
    const { $headlineScore, $seoScore } = this.getMetaBoxNodes();
    const {
      last_headline_text: lastHeadlineText,
    } = await this.getLastAnalyzedHeadline();

    if (!newScore) {
      $headlineScore.html(this.createAnalyzeButton(lastHeadlineText));
    } else {
      $headlineScore.html(`<strong>${newScore}</strong>`);
    }
    if (!newSeoScore) {
      $seoScore.html(this.createAnalyzeButton(lastHeadlineText));
    } else {
      $seoScore.html(`<strong>${newSeoScore}</strong>`);
    }
  }

  async getPostMeta() {
    let postMeta;

    if (!this.postId) return null;
    try {
      postMeta = await wp.apiFetch({
        path: `/cos_headline_studio/v1/get_headline_post_meta/${this.postId}`,
        method: 'GET',
      });
    } catch (err) {
      console.error('Could not fetch post meta');
    }

    return postMeta;
  }

  async getLastAnalyzedHeadline() {
    const postMeta = await this.getPostMeta();
    return postMeta?.cos_last_analyzed_headline;
  }

  setCurrentHeadline() {
    this.headlineElement = document.querySelector('#titlewrap > input[id="title"]');
  }
}

jQuery(() => {
  window.coscheduleHeadlineStudio.classicEditorApp = new ClassicEditor();
  window.coscheduleHeadlineStudio.classicEditorApp.setup();
});

jQuery(window).on('load', () => {
  jQuery.when(jQuery.ready).then(() => {
    doAction('headline_studio_loaded');
  });
});
